import { Component, Input, OnInit } from '@angular/core';

import { AbstractViewFieldChoicesComponent } from '../base/abstract-view-field-choices';

@Component({
  selector: 'app-form-view-select',
  templateUrl: './view-select.component.html',
  styleUrls: ['../view-field/form-view-field.component.scss'],
})
export class FormViewSelectComponent
  extends AbstractViewFieldChoicesComponent
  implements OnInit
{
  @Input() initialValue: string | undefined;

  ngOnInit(): void {
    if (this.initialValue) {
      this.selection = this.initialValue;
    }
  }
}
